import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { updateStubStatus } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class StubStatusUpdateClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      internationalization: this.props.intl.messages.stubStatusUpdate,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          btnLoading: true,
        });
        console.info('aaa', this.props)
        if (this.props.isBatch && this.props.isBatch == 1) {
          values.stubIds = this.props.stubIds;
          values.stubId = '--';
          values.oldStatus = '--';
        } else {
          values.stubId = this.props.stubId;
          values.oldStatus = this.props.oldStatus;
        }
        fetchHandler(updateStubStatus, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label={this.state.internationalization.title1}>
            {getFieldDecorator("status", {
              rules: [
                {
                  required: true,
                  message: this.state.internationalization.placeholder1, // "请选择要修改的状态"
                },
              ],
            })(
              <Radio.Group>
                <Radio key="04" value="04">维护中</Radio>
                <Radio key="05" value="05">离线</Radio>
              </Radio.Group>,
              )}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const StubStatusUpdate = Form.create()(StubStatusUpdateClass);

export default injectIntl(StubStatusUpdate);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubStatusUpdate.js